// Base
import Image from 'next/image'

// Components
import { Flex, Text, Box } from 'yard-utilities/components'

// Assets
import GuaranteeImage from '@images/v25/badges/money-back-guarantee.png'

// Styles
import styles from './MoneyBackGuarantee.module.sass'

const MoneyBackGuarantee = () => {
  return (
    <Box
      borderRadius={{ sm: [16] }}
      padding={{ sm: [0, 24, 32] }}
      backgroundColor="white"
      className={styles.card}
    >
      <Flex flexDirection="column" center rowGap={{ sm: 16 }}>
        <Image
          src={GuaranteeImage}
          alt="Money back guarantee badge"
          width={80}
          height={80}
          className={styles.image}
        />

        <Flex flexDirection="column" center rowGap={{ sm: 16 }}>
          <Text
            tagName="h3"
            variant="title-5"
            align="center"
            transform="capitalize"
          >
            30-day money-back guarantee
          </Text>
          <Text tagName="p" variant="body-1" align="center" textColor="grey-2">
            If you don’t fall in love with RatePunk for whatever reason, we will
            simply refund your money, no questions asked
          </Text>
        </Flex>
      </Flex>
    </Box>
  )
}

export default MoneyBackGuarantee
